import { module } from 'modujs';
import gsap, { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
        this.$li = this.$('li');
    }

    init() {
        this.$li.forEach(el => {
            let data = el.dataset.scrollto;
            data = data.replace('#', '');

            let element = document.querySelector(`.c-card[data-article="${data}"]`);

            ScrollTrigger.create({
                trigger: element,
                start: "top center",
                end: "bottom center",
                onToggle: self => self.isActive && this.setActive(el)
            });

            el.addEventListener('click', () => {
                this.call('scrollTo', document.querySelector('[data-article=' + data + ']'), 'Scroll');
            })
        });
    }

    setActive(li) {
        this.$li.forEach(el => el.classList.remove("is-active"));
        li.classList.add("is-active");
    }

    destroy() {
        super.destroy()
    }
}
